import { useTranslation } from 'react-i18next';
import { Separator } from '@/components/ui/separator.tsx';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { useUpdateNotificationsQuery } from '@/features/notifications/hooks/mutations/use-patch-notifications.ts';
import { TNotification } from '@/features/notifications/schemas/notifications.schemas.ts';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';
import { LoaderIcon } from 'lucide-react';

export const NotificationFooter = () => {
  const { t } = useTranslation();

  const notificationFilter = useNotificationsStore((state) => state.notificationFilter);
  const { data } = useGetNotificationsQuery({ notificationFilter });

  const { mutate: deleteAllNotifications, isPending } = useUpdateNotificationsQuery();

  return (
    <div>
      <Separator className="bg-gray-100 dark:bg-gray-800" />
      <button
        disabled={isPending}
        onClick={() =>
          deleteAllNotifications({
            notificationIds: getUnReadNotificationIds(data?.pages),
            status: 'read',
          })
        }
        className="focus-visible:ring-ring hover:text-accent-foreground flex h-9 w-full items-center justify-center gap-2 overflow-hidden rounded-b-2xl px-4 py-5 text-sm font-medium whitespace-nowrap text-blue-600 transition-colors hover:bg-blue-50 focus-visible:ring-1 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 dark:text-blue-400 dark:hover:bg-blue-900/20"
      >
        {isPending && (
          <LoaderIcon className="size-4 animate-spin text-gray-800" aria-hidden="true" />
        )}
        <span>{t('notifications.markAllAsRead')}</span>
      </button>
    </div>
  );
};

function getUnReadNotificationIds(notifications?: TNotification[]) {
  if (!notifications || notifications?.length === 0) return [];

  const unReadNotificationsIds: string[] = [];
  for (const notification of notifications) {
    if (notification.status === 'unread' && notification?.notificationId) {
      unReadNotificationsIds.push(notification?.notificationId);
    }
  }
  return unReadNotificationsIds;
}
